import { render, staticRenderFns } from "./NavigationBarDomainPicker.vue?vue&type=template&id=a5636f7a&scoped=true"
import script from "./NavigationBarDomainPicker.vue?vue&type=script&lang=js"
export * from "./NavigationBarDomainPicker.vue?vue&type=script&lang=js"
import style0 from "./NavigationBarDomainPicker.vue?vue&type=style&index=0&id=a5636f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5636f7a",
  null
  
)

export default component.exports